class ProductTableSection extends HTMLElement {
  connectedCallback() {
    this.tbody = this.querySelector('.products-tbody');

    // Attach event listeners using event delegation
    if (this.tbody) {
      this.tbody.addEventListener('click', (e) => {
        const row = e.target.closest('.product-row');
        if (!row) return;

        const quantitySelector = row.querySelector('.quantity-selector');
        const input = quantitySelector?.querySelector('.qty-input');

        if (!input) return;

        if (e.target.classList.contains('qty-minus')) {
          const currentVal = parseInt(input.value) || 0;
          const newVal = Math.max(0, currentVal - 1);
          input.value = newVal;
        } else if (e.target.classList.contains('qty-plus')) {
          const currentVal = parseInt(input.value) || 0;
          const newVal = Math.min(99, currentVal + 1);
          input.value = newVal;
        }
      });

      this.tbody.addEventListener('input', (e) => {
        if (e.target.classList.contains('qty-input')) {
          const val = parseInt(e.target.value) || 0;
          e.target.value = Math.max(0, Math.min(99, val));
        }
      });
    }
  }

  getCartData() {
    const rows = this.querySelectorAll('.product-row');
    const items = [];

    rows.forEach((row) => {
      const variantId = row.dataset.variantId;
      const input = row.querySelector('.qty-input');
      const quantity = parseInt(input?.value) || 0;

      if (quantity > 0 && variantId) {
        items.push({ variantId, quantity });
      }
    });

    return items;
  }
}

class URLGenerator extends HTMLElement {
  connectedCallback() {
    this.urlContainer = this.querySelector('.generated-url');
    this.urlText = this.querySelector('.url-text');

    // Use event delegation
    this.addEventListener('click', (e) => {
      if (e.target.matches('button[type="button"]:not(.copy-btn)')) {
        this.generateURL();
      } else if (e.target.classList.contains('copy-btn')) {
        this.copyURL();
      }
    });
  }

  generateURL() {
    const section = this.closest('product-table-section');
    const items = section.getCartData();
    const urlParams = [];

    items.forEach((item) => {
      urlParams.push(`id[]=${item.variantId}&quantity[]=${item.quantity}`);
    });

    if (urlParams.length > 0) {
      const discountInput = this.querySelector('[name="discount-code"]');
      const discountCode = discountInput?.value.trim();

      let fullUrl;
      const cartParams = items.map((item) => `${item.variantId}:${item.quantity}`).join(',');

      if (discountCode) {
        fullUrl = `${window.location.origin}/discount/${discountCode}?redirect=/cart/${cartParams}`;
      } else {
        fullUrl = `${window.location.origin}/cart/${cartParams}`;
      }

      this.urlText.textContent = fullUrl;
      this.urlContainer.classList.remove('hidden');
    } else {
      alert('Please select at least one product with quantity greater than 0');
    }
  }

  copyURL() {
    const urlText = this.urlText.textContent;

    navigator.clipboard
      .writeText(urlText)
      .then(() => {
        const copyBtn = this.querySelector('.copy-btn');
        if (!copyBtn) return;

        const originalText = copyBtn.textContent;
        copyBtn.textContent = 'Copied!';

        setTimeout(() => {
          copyBtn.textContent = originalText;
        }, 2000);
      })
      .catch((err) => {
        console.error('Failed to copy:', err);
        alert('Failed to copy URL. Please copy manually.');
      });
  }
}

// Register custom elements
customElements.define('product-table-section', ProductTableSection);
customElements.define('url-generator', URLGenerator);
